import {
  ADD_ATTRIBUTES,
  ADD_DIMENSION,
  ADD_FACT_TABLE,
  ADD_LINK,
  ADD_REASON,
  DELETE_ATTRIBUTE,
  DELETE_DIMENSION,
  DELETE_FACT,
  DELETE_LINK,
  DELETE_MEASURE,
  HIDE_ATTRIBUTES_MODAL,
  HIDE_DIMENSION_MODAL,
  HIDE_FACT_MODAL,
  HIDE_LINK_MODAL,
  HIDE_MEASURES_MODAL,
  HIDE_OPTIONS_MODAL,
  HIDE_SLIDER_MODAL,
  HIDE_TAGS_MODAL,
  LOAD_REMOVE_MODAL,
  RESET_ATTRIBUTES_MODAL,
  RESET_DIMENSION_MODAL,
  RESET_FACT_MODAL,
  RESET_REASONS_MODAL,
  SET_AGGREGATION_TYPES,
  SET_ATTRIBUTES_MODAL_LOADING,
  SET_CONFIRM_MODAL,
  SET_DATA,
  SET_DATA_TYPES,
  SET_DIMENSION_MODAL_LOADING,
  SET_FACT_MODAL_LOADING,
  SET_FILTER,
  SET_LINK_DIMENSION,
  SET_LINK_FACT,
  SET_LINK_MODAL_LOADING,
  SET_MEASURES_MODAL_LOADING,
  SET_ORIGINAL_DATA,
  SET_REMOVE_ITEMS_MODAL,
  SET_SHOW_HIDE_ATTRIBUTES,
  SET_SHOW_HIDE_MINOR_ELEMENTS,
  SET_SUN_MODEL_LOADING, SET_TAGS, SET_TAGS_LOADING,
  SHOW_ATTRIBUTES_MODAL,
  SHOW_DIMENSION_MODAL,
  SHOW_FACT_MODAL,
  SHOW_LINK_MODAL,
  SHOW_MEASURES_MODAL,
  SHOW_OPTIONS_MODAL,
  SHOW_SLIDER_MODAL,
  SHOW_TAGS_MODAL,
  UNLOAD_DATA,
  UPDATE_ATTRIBUTES,
  UPDATE_DIMENSION,
  UPDATE_FACT_TABLE,
} from './mutation-types';
import eventBus, {SHOW_ATTRIBUTES, SHOW_MEASURES, SHOW_MINOR} from '../../../core/services/event-bus';
import {axiosClient} from '../../../core/services/http.service';
import {v4 as uuidv4} from 'uuid';

export async function loadData({commit, state, dispatch}) {
  commit(SET_SUN_MODEL_LOADING, true);
  const factsAndDimResponse = await axiosClient.get('/api/SunModelEntity');
  const linksResponse = await axiosClient.get('/api/SunModelLink');
  commit(SET_SUN_MODEL_LOADING, false);
  if (factsAndDimResponse.success && linksResponse.success) {
    const data = {
      facts: [],
      dimensions: [],
      links: [],
    };
    data.facts = [...factsAndDimResponse.body.filter(item => item.entityType === 'fact')]
      .map(f => ({...f, tags: JSON.parse(f.tags || '[]')}));
    data.dimensions = [...factsAndDimResponse.body.filter(item => item.entityType === 'dim')]
      .map(f => ({...f, tags: JSON.parse(f.tags || '[]')}));
    data.links = [...linksResponse.body];
    commit(SET_DATA, data);
    commit(SET_ORIGINAL_DATA, data);
    dispatch('filterData');
  }
}

export function filterData({commit, state}) {
  // Create copy of state.sunModel.originalData
  const newData = JSON.parse(JSON.stringify(state.sunModel.originalData));

  newData.facts.forEach(f => {
    f.links = newData.links.filter(l => l.fromEntityId === f.entityId);
  });

  const dimensions = [];
  newData.links.forEach(l => {
    if (l.alias) {
      const newDimId = uuidv4();
      const dimShadow = dimensions.filter(d => d.dimId === l.toEntityId && d.alias === l.alias && d.factId !== l.fromEntityId);
      if (dimShadow.length > 0) {
        dimShadow.forEach(dim => {
          newData.links.push({fromEntityId: l.fromEntityId, toEntityId: dim.newDimId});
        });
      } else {
        dimensions.push({
          factId: l.fromEntityId,
          dimId: l.toEntityId,
          alias: l.alias,
          newDimId: newDimId,
        });
      }
    }
  });

  if (dimensions.length > 0) {
    dimensions.forEach(dim => {
      const dimension = newData.dimensions.find(d => d.entityId === dim.dimId);
      const attributes = dimension.attributes.map(attr => ({
        ...attr,
        entityId: dim.newDimId,
        attributeId: uuidv4(),
        isCopy: true,
        mainAttributeId: attr.attributeId,
      }));
      newData.dimensions.push({
        entityId: dim.newDimId,
        entityDisplayName: dim.alias,
        mainDimName: dimension.entityDisplayName,
        mainDimId: dim.dimId,
        fromEntityId: dim.factId,
        attributes: attributes,
        isCopy: true,
      });
      newData.links.push({fromEntityId: dim.factId, toEntityId: dim.newDimId});
    });
  }

  if (state.sunModel.optionsFilter.filteredFacts) {
    const dimensionsByFacts = [];
    newData.facts = newData.facts.filter((fact) => state.sunModel.optionsFilter.filteredFacts.includes(fact.entityId));
    newData.dimensions = newData.dimensions.filter((dim) => state.sunModel.optionsFilter.filteredFacts.includes(dim.entityId));

    const factsArray = newData.facts.map(f => f.entityId);
    const dimensionsArray = newData.dimensions.map(d => d.entityId);

    newData.links = newData.links.filter((link) => {
      return !!(factsArray.includes(link.fromEntityId) && dimensionsArray.includes(link.toEntityId)) ||
             !!(dimensionsArray.includes(link.fromEntityId) && dimensionsArray.includes(link.toEntityId))
      ;
    });
  }

  // if (state.sunModel.optionsFilter.filteredDimensions) {
  //   let factsByDimensions = [];
  //   newData.dimensions = newData.dimensions.filter((elem) => state.sunModel.optionsFilter.filteredDimensions.includes(elem.entityId));
  //   newData.links = newData.links.filter((link) => {
  //     if (state.sunModel.optionsFilter.filteredFacts.includes(link.fromEntityId)) {
  //       factsByDimensions.push(link.toEntityId)
  //       return true;
  //     }
  //     return false;
  //   });
  // }

  // If we must show measures
  /*if (state.sunModel.optionsFilter.displayMeasures) {
    newData.facts = newData.facts.map(elem => {
      elem.measures = [...elem.measures.filter((elem) => {
        return !(!state.sunModel.optionsFilter.displayMinorElements && elem.minorElement);
      })]
      return elem;
    })
  }*/

  if (!state.sunModel.optionsFilter.displayAttributes) {
    newData.facts = newData.facts.map(elem => {
      elem.attributes = [];
      return elem;
    });
    newData.dimensions = newData.dimensions.map(elem => {
      elem.attributes = [];
      return elem;
    });
  } else {
    newData.facts = newData.facts.map(elem => {
      elem.attributes = [...elem.attributes.filter((elem) => {
        return !(!state.sunModel.optionsFilter.displayMinorElements && elem.minorElement);
      })];
      return elem;
    });
    newData.dimensions = newData.dimensions.map(elem => {
      elem.attributes = [...elem.attributes.filter((elem) => {
        return !(!state.sunModel.optionsFilter.displayMinorElements && elem.minorElement);
      })];
      return elem;
    });
  }

  commit(SET_DATA, newData);
}

export function unloadData({commit}) {
  commit(UNLOAD_DATA);
}

export function showFactModal({commit}, data = null) {
  commit(SHOW_FACT_MODAL, data);
}

export function showDimensionModal({commit}, data = null) {
  commit(SHOW_DIMENSION_MODAL, data);
}

export function showLinkFactModal({commit}, data = null) {
  commit(SHOW_LINK_MODAL, data);
}

export function showOptionsModal({commit}) {
  commit(SHOW_OPTIONS_MODAL);
}

export function showSliderModal({commit}, data = null) {
  commit(SHOW_SLIDER_MODAL, data);
}

export function showTagsModal({commit}, data = null) {
  commit(SHOW_TAGS_MODAL, data);
}

export function hideTagsModal({commit}) {
  commit(HIDE_TAGS_MODAL);
}

export function hideSliderModal({commit}) {
  commit(HIDE_SLIDER_MODAL);
}

export function hideOptionsModal({commit}) {
  commit(HIDE_OPTIONS_MODAL);
}

export function hideFactModal({commit}, factData = null) {
  commit(HIDE_FACT_MODAL);
}

export function hideMeasuresModal({commit}, factData = null) {
  commit(HIDE_MEASURES_MODAL);
}

export function hideAttributesModal({commit}, data) {
  commit(HIDE_ATTRIBUTES_MODAL);
}

export function showMeasuresModal({commit}, data = null) {
  commit(SHOW_MEASURES_MODAL, data);
}

export function showAttributesModal({commit}, data) {
  commit(SHOW_ATTRIBUTES_MODAL, data);
}

export function hideDimensionModal({commit}, factData = null) {
  commit(HIDE_DIMENSION_MODAL);
}

export function hideLinkModal({commit}, factData = null) {
  commit(HIDE_LINK_MODAL);
}

export function updateFilter({commit, dispatch}, data = {}) {
  commit(SET_FILTER, {data});
  dispatch('filterData');
}

export function addReason({commit, state, dispatch}, data) {
  data = {...data};
  const factName = state.dimensionModal.linkFact;
  return new Promise((resolve, reject) => {
    //TODO Make request to create Fact table
    commit(SET_MEASURES_MODAL_LOADING, true);
    setTimeout(() => {
      commit(SET_MEASURES_MODAL_LOADING, false);
      resolve({success: true, data});
      // eventBus.$emit(FACT_ADD, data);
      commit(ADD_REASON, {data: {...data}});
      commit(RESET_REASONS_MODAL);
      dispatch('filterData');
    }, 500);
  });
}


export async function createFactTable({commit, state, dispatch}, data) {
  data = {...data};

  commit(SET_FACT_MODAL_LOADING, true);
  if (typeof data.tags === 'object' && data.tags.length !== 'undefined') {
    data.tags = data.tags.join(',');
  }
  const response = await axiosClient.post('/api/SunModelEntity', data);

  commit(SET_FACT_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_FACT_TABLE, response.body);
    dispatch('filterData');
    commit(RESET_FACT_MODAL);
  }

  return response;
}

export async function updateFactTable({commit, state, dispatch}, data) {
  data = {...data};

  commit(SET_FACT_MODAL_LOADING, true);
  const response = await axiosClient.put('/api/SunModelEntity', data);

  commit(SET_FACT_MODAL_LOADING, false);
  if (response.success) {
    commit(UPDATE_FACT_TABLE, response.body);
    dispatch('filterData');
    commit(RESET_FACT_MODAL);
  }

  return response;
}

export async function createDimension({commit, dispatch, state}, data) {
  data = {...data};
  const factName = state.dimensionModal.linkFact;

  commit(SET_DIMENSION_MODAL_LOADING, true);
  const response = await axiosClient.post('/api/SunModelEntity', data);

  commit(SET_DIMENSION_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_DIMENSION, response.body);
    commit(RESET_DIMENSION_MODAL);

    if (factName) {
      const linkData = {
        fromEntityId: factName,
        toEntityId: data.entityId,
        alias: null,
      };
      dispatch('createLink', linkData);
    }

    dispatch('filterData');
  }

  return response;
}

export async function updateDimension({commit, dispatch, state}, data) {
  data = {...data};

  commit(SET_DIMENSION_MODAL_LOADING, true);
  const response = await axiosClient.put('/api/SunModelEntity', data);

  commit(SET_DIMENSION_MODAL_LOADING, false);
  if (response.success) {
    commit(UPDATE_DIMENSION, response.body);
    commit(RESET_DIMENSION_MODAL);

    dispatch('filterData');
  }

  return response;
}

export async function addAttribute({commit, state, dispatch}, data) {
  data = {...data};

  commit(SET_ATTRIBUTES_MODAL_LOADING, true);
  const response = await axiosClient.post('/api/SunModelAttribute', data);

  commit(SET_ATTRIBUTES_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_ATTRIBUTES, response.body);
    commit(RESET_ATTRIBUTES_MODAL);
    dispatch('filterData');
  }
  return response;
}

export async function updateAttribute({commit, state, dispatch}, data) {
  data = {...data};

  commit(SET_ATTRIBUTES_MODAL_LOADING, true);
  const response = await axiosClient.put('/api/SunModelAttribute', data);

  commit(SET_ATTRIBUTES_MODAL_LOADING, false);
  if (response.success) {
    commit(UPDATE_ATTRIBUTES, response.body);
    commit(RESET_ATTRIBUTES_MODAL);
    dispatch('filterData');
  }
  return response;
}

export function showAttributes() {
  eventBus.$emit(SHOW_ATTRIBUTES);
}

export function showMeasures() {
  eventBus.$emit(SHOW_MEASURES);
}

export function showMinor() {
  eventBus.$emit(SHOW_MINOR);
}

export async function createLink({commit, dispatch}, data) {
  data = {...data};

  commit(SET_LINK_MODAL_LOADING, true);
  const response = await axiosClient.post('/api/SunModelLink', data);

  commit(SET_LINK_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_LINK, response.body);
    dispatch('filterData');
  }

  return response;
}

export function setDimensionLink({commit}, data) {
  commit(SET_LINK_DIMENSION, {data});
}

export function setFactLink({commit}, data) {
  commit(SET_LINK_FACT, data);
}

export async function deleteAttribute({commit, dispatch}, attributeId) {
  const response = await axiosClient.delete(`/api/SunModelAttribute/${attributeId}`);
  if (response.success) {
    commit(DELETE_ATTRIBUTE, attributeId);
    dispatch('filterData');
  }
  return response;
}

export function deleteMeasure({commit, dispatch}, data) {
  commit(DELETE_MEASURE, {data});
  dispatch('filterData');
}

export function setConfirmModal({commit, dispatch}, data) {
  commit(SET_CONFIRM_MODAL, {data});
}

export function setRemoveItemsModal({commit, dispatch}, data) {
  commit(SET_REMOVE_ITEMS_MODAL, {data});
}

export function toggleRemoveItemsModal({commit}) {
  commit(LOAD_REMOVE_MODAL);
}

export async function deleteDimension({commit, dispatch}, entityId) {
  const response = await axiosClient.delete(`/api/SunModelEntity/${entityId}`);
  if (response.success) {
    commit(DELETE_DIMENSION, entityId);
    dispatch('filterData');
  }
  return response;
}

export async function deleteLink({commit, dispatch}, linkId) {
  const response = await axiosClient.delete(`/api/SunModelLink/${linkId}`);
  if (response.success) {
    commit(DELETE_LINK, linkId);
    dispatch('filterData');
  }
  return response;
}

export async function deleteFact({commit, dispatch}, entityId) {
  const response = await axiosClient.delete(`/api/SunModelEntity/${entityId}`);
  if (response.success) {
    commit(DELETE_FACT, entityId);
    dispatch('filterData');
  }
  return response;
}

export async function getAggregationTypes({commit}) {
  const response = await axiosClient.get('/api/SunModelAggregationTypes');
  if (response.success) {
    commit(SET_AGGREGATION_TYPES, response.body);
  }
  return response;
}

export async function getDataTypes({commit}) {
  const response = await axiosClient.get('/api/SunModelDataTypes');
  if (response.success) {
    commit(SET_DATA_TYPES, response.body);
  }
  return response;
}

export async function showHideAttributes({commit, dispatch}, display) {
  commit(SET_SHOW_HIDE_ATTRIBUTES, display);
  dispatch('filterData');
}

export async function showHideMinorElements({commit, dispatch}, display) {
  commit(SET_SHOW_HIDE_MINOR_ELEMENTS, display);
  dispatch('filterData');
}

export async function getTags({commit}) {
  commit(SET_TAGS_LOADING, true);
  try {
    const {body, success} = await axiosClient.get('/api/SunModelTag');
    commit(SET_TAGS_LOADING, false);

    if (success) {
      commit(SET_TAGS, body);
    }
  } catch (e) {
    commit(SET_TAGS_LOADING, false);
  }
}

export async function deleteTag({dispatch, commit}, {id}) {
  try {
    const {success} = await axiosClient.delete('/api/SunModelTag/' + id);
    if (success) {
      await dispatch('getTags');
    }
  } catch (e) {
  }
}

export async function createTag({dispatch, commit}, {name}) {
  try {
    const {success} = await axiosClient.post('/api/SunModelTag/', {tagName: name});
    if (success) {
      await dispatch('getTags');
    }
  } catch (e) {
  }
}

export async function updateTag({dispatch, commit}, tag) {
  try {
    const {success} = await axiosClient.put('/api/SunModelTag/', tag);
    if (success) {
      await dispatch('getTags');
    }
  } catch (e) {
  }
}
